import * as React from "react";
import type { SVGProps } from "react";
const SvgBulgaria = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 720" {...props}>
    <path
      d="M0 0h1280v720H0z"
      style={{
        fill: "#fff",
      }}
    />
    <path
      d="M0 240h1280v480H0z"
      style={{
        fill: "#00956e",
      }}
    />
    <path
      d="M0 480h1280v240H0z"
      style={{
        fill: "#d42a27",
      }}
    />
  </svg>
);
export default SvgBulgaria;
